import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProjectAttendee } from '../../../../models/projects/project-attendee.model';
import { Project } from '../../../../models/projects/project.model';

@Component({
    selector: 'dialog-list-attendees',
    templateUrl: './dialog-list-attendees.component.html',
    styleUrls: ['./dialog-list-attendees.component.scss'],
})
export class DialogListAttendeesComponent {
    @Input() public isMemberOrOwnerOfProject: boolean;
    @Input() public project: Project;
    public removeUserModalVisible: any;
    public selectedAttendee = new ProjectAttendee();
    public updateOwnerModalVisible: boolean;
    public userToUpdate: ProjectAttendee;
    @Input() public visible: boolean;
    @Output() public visibleChange = new EventEmitter<boolean>();

    constructor() {}

    public closeAttendeesModal(slidePanel: any) {
        slidePanel.slideToCenter();
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public getLabel(firstName: string, lastName: string) {
        if (firstName?.length && lastName?.length) {
            return firstName.slice(0, 1) + lastName.slice(0, 1);
        }
        return '';
    }

    public toggleRemoveUserModal($event: any, profile: ProjectAttendee) {
        $event.stopPropagation();
        this.userToUpdate = profile;
        this.removeUserModalVisible = !this.removeUserModalVisible;
    }

    public toggleUpdateOwnerModal($event: any, profile: ProjectAttendee) {
        $event.stopPropagation();
        this.userToUpdate = profile;
        this.updateOwnerModalVisible = !this.updateOwnerModalVisible;
    }
}
